<template>
  <div class="embed-responsive embed-responsive-16by9">
    <picture
      class="thumb__content embed-responsive-item"
      :style="{ backgroundImage: `url(${course.thumb})`}"
    ></picture>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, default: () => ({}) }
  }
}
</script>

<style scoped lang="scss">
  .thumb__content {
    background-size: cover;
    background-position: center center;
    border-radius: 8px;
  }
</style>